module.exports = __webpack_public_path__ + "static/media/products_old.75646ccc.csv";